import React, { useState } from 'react';
import { TextField, Button, Box, Alert, CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';
import { createDestaque } from '../../services/destaqueService';

const FormDestaque = ({ instituicaoId, onSuccess }) => {
  const [formData, setFormData] = useState({
    titulo: '',
    descricao: '',
    link: '',
    imagem: null
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  const resetForm = () => {
    setFormData({
      titulo: '',
      descricao: '',
      link: '',
      imagem: null
    });
    setImagePreview(null);
    setError(null);
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    
    if (name === 'imagem') {
      const file = files[0];
      if (file) {
        setFormData(prev => ({ ...prev, imagem: file }));
        const reader = new FileReader();
        reader.onloadend = () => {
          setImagePreview(reader.result);
        };
        reader.readAsDataURL(file);
      }
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const formDataToSend = new FormData();
      formDataToSend.append('titulo', formData.titulo);
      formDataToSend.append('descricao', formData.descricao);
      formDataToSend.append('link', formData.link);
      if (formData.imagem) {
        formDataToSend.append('imagem', formData.imagem);
      }

      await createDestaque(instituicaoId, formDataToSend);
      resetForm();
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      console.error('Erro ao salvar destaque:', error);
      setError('Falha ao salvar o destaque. Por favor, tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} noValidate>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <TextField
        required
        label="Título"
        name="titulo"
        value={formData.titulo}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Descrição"
        name="descricao"
        value={formData.descricao}
        onChange={handleChange}
        fullWidth
        margin="normal"
        multiline
        rows={4}
      />
      <TextField
        label="Link"
        name="link"
        value={formData.link}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />
      
      <Button
        variant="contained"
        component="label"
        sx={{ mt: 2 }}
      >
        {formData.imagem ? 'Alterar Imagem' : 'Selecionar Imagem'}
        <input
          type="file"
          hidden
          name="imagem"
          accept="image/*"
          onChange={handleChange}
        />
      </Button>

      {imagePreview && (
        <Box sx={{ mt: 2 }}>
          <img
            src={imagePreview}
            alt="Preview"
            style={{ maxWidth: '100%', maxHeight: '200px', objectFit: 'contain' }}
          />
        </Box>
      )}

      <Button
        type="submit"
        variant="contained"
        color="primary"
        sx={{ mt: 3 }}
        disabled={loading}
      >
        {loading ? <CircularProgress size={24} /> : 'Salvar Destaque'}
      </Button>
    </Box>
  );
};

FormDestaque.propTypes = {
  instituicaoId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onSuccess: PropTypes.func
};

export default FormDestaque;